
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/course",
      function () {
        return require("private-next-pages/compare/course.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/course"])
      });
    }
  